import React from 'react';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { Theme } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import { SxProps } from '@mui/material/styles';

export type CardItemProps = {
  variant: 'pink' | 'purple' | 'grey' | 'blue';
  size: 'extraSmall' | 'small' | 'medium';
  emoji: React.ReactNode;
  onClick?: () => void;
  rounded?: boolean;
  sx?: SxProps<Theme>;
};

const getColor = (variant: string, theme: Theme) => {
  switch (variant) {
    case 'purple':
      return {
        bgColor: theme.palette.purple[20],
        color: theme.palette.purple[100],
      };
    case 'pink':
      return {
        color: theme.palette.red[60],
        bgColor: theme.palette.red[20],
      };
    case 'blue':
      return {
        color: theme.palette.blue[60],
        bgColor: theme.palette.blue[20],
      };
    default:
      return {
        bgColor: theme.palette.neutral[10],
        color: theme.palette.neutral[30],
      };
  }
};

const getSize = (size: string) => {
  switch (size) {
    case 'extraSmall':
      return '35px';
    case 'small':
      return '40px';
    case 'medium':
    default:
      return '46px';
  }
};

const getRounded = (rounded?: boolean) => {
  if (rounded) return '50px';
  return '5px';
};

const CardItem = ({ variant, size, emoji, onClick, rounded, sx }: CardItemProps) => {
  const theme = useTheme();
  const { color, bgColor } = getColor(variant, theme);
  const width = getSize(size);
  const height = getSize(size);
  const borderRadius = getRounded(rounded);
  const StyledTypography = styled(Typography)(
    () => `
        color: ${color};
        background-color: ${bgColor};
        width: ${width};
        min-width: ${width};
        height: ${height};
        border-radius: ${borderRadius};
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        font-size: 24px;

        &:hover {
          cursor: 'pointer';
        }
      `,
  );

  return (
    <StyledTypography sx={sx} onClick={onClick}>
      {emoji}
    </StyledTypography>
  );
};

export default CardItem;
export { CardItem };
